<template>
  <div id="channel-widget">
    <div id="channelWidgetPopupTarget">
      <span style="visibility: hidden;">_^_</span>
    </div>
    <div id="channelWidgetPopover"></div>
    <b-popover container="channelWidgetPopover" target="channelWidgetPopupTarget" triggers="click" :show.sync="showChannelWidgetPopover" placement="left">
      <div class="row" style="height: 20px; margin-top: -15px; margin-right: -20px;">
        <div class="col-12" style="margin-top: 0.5rem;">
          <div class="popup-header">
            <div class="close_btn_container">
              <button class="btn_close" aria-label="close" @click="closeChannelWidget">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <template v-if="isAuthenticated && isUserAuthenticatedOnFirebase">
          <course-section-channel :uuid="userObjLocal.uuid" :channelType="'ALL'" :is-loading-on-widget="true" v-if="showChannel"></course-section-channel>
        </template>
        <template v-else>
          <div class="text-center">
            ...
          </div>
        </template>
      </div>
    </b-popover>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import '../assets/theme/default/sass/global.scss'
  //import '../assets/theme/default/css/defaultTheme.min.css'
  import '../assets/module/css/explore/explore.min.css'
  import CourseSectionChannel from './course/components/CourseSectionChannel'
  import { StorageFactory } from '../storageFactory'
  import { auth, db } from '../firebase'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'channel-widget',
    props: ['key', 'secret', 'userId'],
    components: {
      CourseSectionChannel
    },
    data: () => {
      return {
        institutionId: null,
        isAuthenticated: false,
        userObjLocal: {},
        showChannel: false,
        showChannelWidgetPopover: false,
        isUserAuthenticatedOnFirebase: false,
        isGuestLogin: (localStore.getItem('userrole') === 'Guest')
      }
    },
    mounted () {
      if (this.$route.query) {
        this.key = this.$route.query.key
        this.secret = this.$route.query.secret
        this.userId = this.$route.query.userId
        this.authenticateWidget()
      }
      window.addEventListener('message', (event) => {
        if (event.data.name === 'OpenChannel') {
          let data = event.data.data
          this.userId = data.userId
          this.loadLoginUser()
          this.$store.commit('LOAD_USER_OBJECT', this.userObjLocal)
          setTimeout(() => {
            this.showChannelWidget()
          }, 500)
        }
      })
    },
    methods: {
      ...mapActions([
        'loadAuthenticateWidget',
        'loadLoginCourseReportingWidgetUser',
        'loadUserJwt',
        'loadAllChannels'
      ]),
      async authenticateWidget () {
        this.institutionId = await this.loadAuthenticateWidget({key: this.key, secret: this.secret, type: 'COURSE_REPORTING'})
        if (this.institutionId) {
          this.loadLoginUser()
          this.isAuthenticated = true
        } else {
          this.isAuthenticated = false
        }
      },
      async loadLoginUser () {
        let data = {
          userId: this.userId
        }
        this.userObjLocal = await this.loadLoginCourseReportingWidgetUser({institutionId: this.institutionId, data: data})
        this.loadChannelSetup()
      },
      loadChannelSetup () {
        this.loadUserJwt().then(res => {
          auth.signInWithCustomToken(res).then(result => {
            this.loadAllChannels().then(data => {
              this.isUserAuthenticatedOnFirebase = true
            })
          })
        })
      },
      showChannelWidget () {
        this.showChannel = true
        this.showChannelWidgetPopover = true
        window.parent.postMessage({name: 'ShowChannelWidgetPopover'}, '*')
      },
      closeChannelWidget () {
        this.showChannel = false
        this.showChannelWidgetPopover = false
        window.parent.postMessage({name: 'HideChannelWidgetPopover'}, '*')
      }
    }
  }
</script>

<style>
  #channelWidgetPopover:before {
    content: ' ';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2;
  }

  #channelWidgetPopover .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 100%;
    width: 100%;
    height: calc(100vh - 20px) !important;
    font-family: Avenir, sans-serif !important;
    font-size: 14px;
  }

  #channelWidgetPopover .popover .arrow {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/ChannelWidgetApp.vue